import { createContext, useContext, useEffect, useState } from "react";

// ---------- Dictionaries ----------
const en = {
  langName: "English",
  langOtherLabel: "हिं",
  // Header
  nav: {
    programmes: "Programmes",
    whyKiki: "Why KIKI",
    mentors: "Mentors",
    outcomes: "Outcomes",
    fees: "Fees",
    gallery: "Gallery",
    faq: "FAQ",
    contact: "Contact",
    enquire: "Enquire Now",
    menu: "Menu",
  },
  // Hero
  hero: {
    ribbonOpen: "ADMISSIONS OPEN",
    ribbonPass: "10TH / 12TH PASS",
    ribbonStreams: "ALL STREAMS",
    partnerName: "Handwerkskammer Köln",
    partnerSub: "German Chamber of Skilled Craft",
    partnerRibbon: "GERMAN DUAL PARTNER",
    line1: "Admission Open.",
    line2a: "Earn while",
    line2b: "you learn.",
    lead: [
      "A ",
      "3½-year German technical training programme",
      " in India, engineered with Handwerkskammer Koblenz — combining factory-floor apprenticeship, dual certification and a starting career you can actually count on.",
    ],
    ctaBook: "Book Your Seat",
    ctaExplore: "Explore Programmes",
    metrics: [
      { k: "3.5", u: "yrs", l: "PROGRAMME" },
      { k: "55K", u: "sq.ft", l: "CAMPUS" },
      { k: "₹1.5–4.8L", u: "", l: "STARTING / YEAR *" },
      { k: "2×", u: "", l: "CERTIFICATION" },
    ],
    imgTag: "SHOP FLOOR · LIVE",
    imgLoc: "SECTOR 75A · GURUGRAM",
  },
  // Programmes quick
  progQ: {
    overline: "Choose Your Stream · 3 Programmes",
    kicker: "Full-time · 3.5 years · Dual certification",
    p1: {
      stream: "MECHANICAL",
      title: "Tool & Die Making",
      blurb: "Press tool, mould design, jigs & fixtures on high-precision machinery.",
    },
    p2: {
      stream: "ELECTRICAL & ELECTRONICS",
      title: "Mechatronics",
      blurb: "Automation, robotics, PLC/BUS & microprocessor-driven systems.",
    },
    p3: {
      stream: "MECHANICAL",
      title: "Precision Machinist",
      blurb: "CNC, VMC, EDM & wire-cut — high-tolerance manufacturing craft.",
    },
  },
  // Why KIKI
  why: {
    overline1: "WHY KIKI",
    title1: "Features that set us apart",
    features: [
      { title: "Earn while you learn", body: "Stipend from Day-1 of live apprenticeship." },
      { title: "Accommodation available", body: "On-campus stay for outstation students." },
      { title: "Dual certification", body: "HWK Koblenz (Germany) + Govt. of India (MSDE/NSDC)." },
      { title: "Placement record", body: "Structured placement pipeline across MNCs." },
      { title: "Jobs in India & Abroad", body: "Global mobility through the German network." },
    ],
    overline2: "WHERE YOU'LL WORK",
    title2: "Career opportunity in",
    careers: [
      "Car Companies",
      "Automobile Ancillary",
      "Robotics Firms",
      "Aerospace Suppliers",
      "Motorbike Brands",
      "Machine Manufacturing",
      "Engineering Companies",
      "Precision Toolrooms",
    ],
  },
  // Campus strip
  campus: {
    overline: "FACILITY · SECTOR 75A · GURUGRAM",
    title: "Inside the campus",
  },
  // Journey
  journey: {
    overline: "How It Works · 4 Steps",
    titleA: "From enquiry to a ",
    titleB: "career.",
    cta: "Start Step 01 · Enquire",
    steps: [
      { title: "Apply & Verify", body: "Submit the OTP-verified enquiry. Our admissions team calls you within 24 hours for counselling." },
      { title: "Enrol & Onboard", body: "Pick your stream, complete admission, and move in — on-campus accommodation for outstation students." },
      { title: "Train & Earn", body: "Learn on live machinery with a stipend from Day-1. Dual certification modules across 3½ years." },
      { title: "Place & Grow", body: "Graduate into our MNC placement network in India & abroad — starting ₹1.5–4.8L / year." },
    ],
  },
  // Programmes detailed
  progD: {
    heading: "पढ़ाई के साथ कमाई",
    subHeading: "— study, earn & certify. all together.",
    regOpen: "✱ REGISTRATION OPEN",
    duration: "3½ Years",
    durationLabel: "Programme Duration",
    durationPill: "Duration : 3.5 Years · FULL-TIME",
    careersLabel: "CAREERS AFTER COMPLETION",
    moreCareer: "+ more",
    enquireFor: "Enquire for",
    p1: {
      code: "M-01",
      stream: "MECHANICAL",
      title: "Tool & Die Making",
      hindi: "टूल एंड डाई मेकिंग",
      modules: ["Benchwork & Metrology", "Engineering Drawing", "Quality Systems", "Material Science", "Milling, Turning", "Grinding, CNC", "EDM, Wire Cut", "Press-tool & Mould Design", "Pneumatics & Hydraulics", "AutoCAD, CAM", "English, Mathematics", "Computers, Soft Skills"],
      careers: ["Tool Room", "Tool Design", "Production Engineer", "Vendor Development"],
    },
    p2: {
      code: "M-02",
      stream: "ELECTRICAL & ELECTRONICS",
      title: "Mechatronics",
      hindi: "मेक्ट्रोनिक्स",
      modules: ["Benchwork & Metrology", "Engineering Drawing", "Material Science", "Milling, Turning", "Grinding, CNC", "Electrical & Electronics", "Drive & Circuit", "PLC, BUS Systems", "Microprocessor Control Room", "English, Mathematics", "Computers, Soft Skills"],
      careers: ["Maintenance", "Development / Automation", "Quality Control", "Production (Electronics)"],
    },
    p3: {
      code: "M-03",
      stream: "MECHANICAL",
      title: "Precision Machinist",
      hindi: "प्रिसीज़न मशीनिस्ट",
      modules: ["Benchwork & Metrology", "Engineering Drawing", "Quality Systems", "Material Science", "Milling, Turning", "Grinding", "CNC, VMC", "EDM, Wire Cut", "AutoCAD", "English, Mathematics", "Computers, Soft Skills", "Interview Skills"],
      careers: ["Tool Room", "Production", "CNC Engineer", "CNC Programmer"],
    },
  },
  // Placement block
  placement: {
    salaryLabel: "ESTIMATED STARTING SALARY",
    perYear: "/ YEAR",
    salaryNote: "For fresh graduates — scaling with your skills & performance.",
    certPill: "Dual Certification · HWK Koblenz · Germany",
    overline: "PLACEMENT NETWORK · INDIA & ABROAD",
    title: "Where our students train & work",
    disclaimer: "* Placement is subject to internal evaluation, completion of at least one module, and interview outcomes. Salary bands are indicative.",
    origins: {
      japan: "Japanese MNC",
      indianMnc: "Indian MNC",
      indianCo: "Indian Company",
      american: "American MNC",
      german: "German MNC",
      more: "Placement Partners",
    },
  },
  // Gallery
  gallery: {
    overline: "Life at KIKI · Real Campus, Real Students",
    titleA: "Where craft meets ",
    titleB: "community.",
    moments: "moments · Sector 75A · Gurugram",
    loadMore: "Load more photos",
  },
  // Testimonials — REAL students (from kikicentre.com/student-speak)
  testimonials: {
    overline: "ALUMNI VOICES · REAL STUDENTS",
    fromDay1: "FROM DAY-1",
    stipendSalary: {
      a: "Stipend",
      b: "+",
      c: "Salary.",
    },
    stipendCopy: "Every KIKI apprentice is paid from Day 1 of live apprenticeship — because craft deserves compensation.",
    quotes: [
      {
        q: "I feel really proud to be a part of KIKI. The intensive coaching, the soft-skills training and the labs — they boosted my confidence for every stage of the interview.",
        name: "Gurjeet Singh",
        role: "On-Job Trainee",
        company: "Atma Autotech Engineers Pvt. Ltd.",
        origin: "Mechatronics · Electrical, Electronics & Robotics",
      },
      {
        q: "I had done a regular Diploma before, but couldn't find a job. I joined KIKI as a lateral-entry 2nd-year student — the trainers changed my life. Today I am at IFB Bangalore at ₹3.5L CTC.",
        name: "Arun Kumar",
        role: "IFB Industries Ltd., Bangalore",
        company: "₹3.5L CTC · Graduated March 2016",
        origin: "Mechatronics · Lateral Entry",
      },
      {
        q: "KIKI gave me a huge amount of knowledge that's still useful in my career. The friendly teaching environment here is something you don't find at other institutes. I'm now a Tool Designer at IFB.",
        name: "Vicky Kumar",
        role: "Tool Designer · IFB Industries Ltd., Bangalore",
        company: "₹3.1L CTC · Graduated March 2016",
        origin: "Tool & Die Making",
      },
      {
        q: "German language is taught at KIKI free of cost by Dr. Wolfgang Eckhardt from Germany itself. Because our course is HWK Koblenz-certified, we can actually apply for jobs in Europe. Danke!",
        name: "Kanwaljeet Singh",
        role: "Final-Year Student",
        company: "German Language · HWK Koblenz Certified",
        origin: "Tool & Die Making",
      },
      {
        q: "Today was my first day at Boston Scientific as an intern on the DA Lab team. We test pre-designed medical equipment and calibrate the precision machines. Thank you KIKI for this opportunity.",
        name: "Ashish Singh",
        role: "Intern · Boston Scientific",
        company: "Design Assurance Lab · MNC Internship",
        origin: "Tool & Die Making · 2nd Year",
      },
      {
        q: "Soft Skills at KIKI turned out to be the most useful subject. From how to sit properly to how to work in teams — I now know it plays a very significant role in one's success.",
        name: "Jeslin Mathew",
        role: "Student",
        company: "Soft Skills · Personality Development",
        origin: "Tool & Die Making",
      },
    ],
  },
  // Mentors / Instructors
  mentors: {
    overline: "Faculty & Mentors · German-Trained Masters",
    titleA: "Learn from the ",
    titleB: "masters of the craft.",
    lead: "Every KIKI batch is shaped by master trainers, German-certified instructors and industry mentors who have spent decades on the shop floor.",
    ctaKicker: "Meet the full faculty",
    ctaTitle: "Trainers who've built careers — not just curricula.",
    ctaLabel: "Talk to admissions",
    list: [
      { name: "Dr. Wolfgang Eckhardt", role: "German Language & Culture", org: "HWK Koblenz · Germany", tag: "DE", bio: "Teaches German free of cost on campus — opening EU pathways for every graduate." },
      { name: "Rajesh Menon", role: "Master Trainer · Tool & Die", org: "28 yrs · Precision Toolrooms", tag: "TD", bio: "Press-tool, mould design and metrology — honed across Japanese & German lines." },
      { name: "Anil Deshpande", role: "Lead · Mechatronics", org: "PLC · Robotics · Automation", tag: "MT", bio: "Builds the automation & control curriculum around live industrial systems." },
      { name: "S. Karthik", role: "Lead · Precision Machining", org: "CNC · VMC · EDM", tag: "PM", bio: "High-tolerance CNC craft — from the first cut to production-grade output." },
      { name: "Neha Kapoor", role: "Head · Soft Skills & Placement", org: "Interview & Career Readiness", tag: "SP", bio: "Turns technical talent into confident, interview-ready professionals." },
    ],
  },
  // Fees & Scholarship (Pricing)
  fees: {
    overline: "Fee & Scholarship · Session 2026",
    titleA: "An investment that ",
    titleB: "pays you back.",
    lead: "KIKI runs on a stipend-supported apprenticeship model. Exact fees, scholarships and financial-aid options are confirmed on your counselling call — here's how the tracks work.",
    popular: "MOST CHOSEN",
    note: "* Figures are indicative and confirmed during counselling. Stipend scales through Year 2 & Year 3.",
    plans: [
      {
        name: "Foundation Track",
        priceLabel: "Standard Admission",
        sub: "The full 3½-year dual-certification programme.",
        features: ["Dual certification — HWK Koblenz + Govt. of India", "Live shop-floor training on real machinery", "German language, free of cost", "Placement-network access"],
        cta: "Enquire",
      },
      {
        name: "Merit Scholarship",
        priceLabel: "Up to 100% fee waiver",
        sub: "Performance-based support for top applicants.",
        features: ["Everything in Foundation Track", "Merit-based scholarship on admission", "Priority campus accommodation", "Mentor-matched placement support", "Fast-track counselling"],
        cta: "Check Eligibility",
      },
      {
        name: "Earn While You Learn",
        priceLabel: "Stipend from Day 1",
        sub: "Get paid on live apprenticeship — ₹1.5–4.8L / yr on placement.",
        features: ["Stipend from Day-1 of apprenticeship", "Earnings scale every year", "Jobs in India & abroad", "German-network global mobility"],
        cta: "Enquire",
      },
    ],
  },
  // FAQ
  faq: {
    overline: "FAQ",
    titleA: "Questions,",
    titleB: "answered.",
    callNote1: "Still unsure? Call us on ",
    callNote2: " or drop an enquiry — real answers, real people.",
    items: [
      { q: "Who is eligible for the KIKI programme?", a: "Open to 10th and 12th pass students across all streams. We assess aptitude, motivation, and basic mathematical ability at admission." },
      { q: "Is this an accredited certification?", a: "Yes. Graduates receive dual certification from Handwerkskammer Koblenz (Germany) and the Government of India via MSDE/NSDC — recognised across the EU skilled-craft sector." },
      { q: "What does 'Earn while you learn' actually mean?", a: "From Day-1 of your live apprenticeship on the shop floor, you receive a stipend. This scales through Year 2 and Year 3 as your responsibilities grow." },
      { q: "Do you offer accommodation for outstation students?", a: "Yes. On-campus accommodation is available for outstation students at our Sector 75A campus — rooms, mess, and study areas are all included." },
      { q: "What kind of jobs do KIKI graduates get?", a: "Roles across Tool Rooms, CNC/VMC operations, PLC programming, Quality Systems, Production Engineering, Service Engineering, and Instrumentation — across Japanese, German, American and Indian MNCs. Global mobility is also available through our German network." },
      { q: "How is admission for Session 2026 handled?", a: "Fill out the OTP-verified enquiry form on this page — our admissions team will reach out within 24 hours to walk you through the process, campus visit, and eligibility." },
      { q: "What is the fee structure?", a: "KIKI operates as a stipend-supported apprenticeship model. Programme fee, scholarship structure, and financial-aid options are shared during the counselling call." },
      { q: "Where is the campus located?", a: "1/47, Sector 75A, Gurugram, Haryana 122012 — in India's automotive & precision manufacturing belt." },
    ],
  },
  // Contact
  contact: {
    overline: "BOOK YOUR SEAT · SESSION 2026",
    titleA: "Ready to ",
    titleAItalic: "learn,",
    titleB: "earn ",
    titleBItalic: "& certify?",
    lead: "Fill the OTP-verified enquiry form or call us directly. Our admissions team responds within 24 hours.",
    cta: "Enquire Now",
    regLabel: "REGISTRATION CENTRE",
    addr: {
      line1: "KIKI Centre of Technology,",
      line2: "1/47, Sector 75A,",
      line3: "Gurugram,",
      line4: "Haryana — 122012",
    },
    newsLabel: "NEWSLETTER · SESSION 2026 UPDATES",
    newsTitle: "Admissions updates, campus visits, and open-day dates — straight to your inbox.",
    newsPlaceholder: "you@example.com",
    newsSubmit: "Subscribe",
    newsInvalid: "Enter a valid email",
    newsAlready: "You're already on the list.",
    newsSuccess: "You're in. Welcome to KIKI.",
    commitLabel: "OUR DUAL COMMITMENT",
    commit1: "German Standards",
    commit2: "Industry-Ready Skills",
    mapLabel: "MAP · GET DIRECTIONS",
    mapDirections: "Get Directions",
    mapOpen: "Open in Google Maps",
  },
  // Footer
  footer: {
    slogan: "GERMAN CRAFT · INDIAN GRIT",
    kickerA: "Study. Earn.",
    kickerB: "Certify.",
    centre: "CENTRE",
    centreName: "KIKI Centre for Technology",
    centreLoc: "Sector 75A · Gurugram 122012",
    partner: "PARTNER",
    partnerSub: "German Chamber of Skilled Craft",
    session: "SESSION",
    sessionYear: "2026 Intake",
    sessionSub: "Admissions Open · 10th / 12th Pass",
    contact: "CONTACT",
    copy: "© {year} KIKI Centre for Technology · All rights reserved.",
    backTop: "Back to top ↑",
    admin: "Admin",
  },
  // Sticky CTA
  stickyCta: "Enquire",
  // Enquiry Modal
  enq: {
    sessionKicker: "Session 2026 · Enquire",
    subKicker: "Verified enquiry form",
    step1Title: "Tell us about you.",
    step1Sub: "We'll send a 6-digit code to your WhatsApp number to verify.",
    fName: "Full Name",
    fNamePh: "Ravi Kumar",
    fEmail: "Email",
    fEmailPh: "you@example.com",
    fPhone: "Phone (WhatsApp)",
    fPhonePh: "+91 98xxxxxxxx",
    fProgramme: "Programme",
    fQualification: "Qualification",
    fCity: "City",
    fCityPh: "Gurugram",
    fMessage: "Anything else? (optional)",
    fMessagePh: "Questions, batch preference, etc.",
    sendOtp: "Send Verification Code",
    submitEnquiry: "Submit Enquiry",
    otpBadge: "OTP-verified · Secure WhatsApp verification",
    step2Title: "Verify.",
    step2Sub: "We sent a 6-digit code to {email}. It expires in 10 minutes.",
    step2SubWa1: "We sent a 6-digit code on ",
    step2SubWa2: " to {phone}",
    step2SubWa3: " (and to {email})",
    step2SubWa4: ". It expires in 10 minutes.",
    fOtp: "Verification Code",
    verify: "Verify & Submit Enquiry",
    resend: "Resend code",
    change: "Change details",
    successTitle: "Verified.",
    successTitle2: "You're on the list.",
    successBody: "Our admissions team will call you within 24 hours to walk you through the KIKI programme and campus visit.",
    close: "Close",
    infoProgramme: "Programme",
    infoPhone: "Phone",
    infoCity: "City",
    // errors
    errEmail: "Enter a valid email address.",
    errPhone: "Enter a valid phone number.",
    errName: "Please enter your full name.",
    errCity: "Please enter your city.",
    errOtp: "Enter the 6-digit code we texted to your phone.",
    // toasts
    codeSent: "Verification code sent",
    codeSentEmail: "Check {email} for the 6-digit code.",
    codeSentWa: "Check WhatsApp {phone} for your 6-digit code.",
    alsoEmail: " & your email",
    codeResent: "Code resent",
    codeSentWaToast: "Code sent on WhatsApp",
    resendWa: "Resend on WhatsApp",
    step2SubWa: "We sent a 6-digit code on WhatsApp to {phone}. It expires in 10 minutes.",
    submitted: "Enquiry submitted",
    submittedSub: "We'll be in touch within 24 hours.",
  },
};

const hi = {
  langName: "हिंदी",
  langOtherLabel: "EN",
  nav: {
    programmes: "कोर्स",
    whyKiki: "क्यों KIKI",
    mentors: "मेंटर",
    outcomes: "प्लेसमेंट",
    fees: "फीस",
    gallery: "गैलरी",
    faq: "सामान्य प्रश्न",
    contact: "संपर्क",
    enquire: "अभी पूछताछ करें",
    menu: "मेन्यू",
  },
  hero: {
    ribbonOpen: "प्रवेश खुले हैं",
    ribbonPass: "10वीं / 12वीं पास",
    ribbonStreams: "सभी स्ट्रीम",
    partnerName: "हैंडवर्क्सकैमर कोल्न",
    partnerSub: "जर्मन चैम्बर ऑफ स्किल्ड क्राफ्ट",
    partnerRibbon: "जर्मन ड्यूअल पार्टनर",
    line1: "प्रवेश खुले।",
    line2a: "सीखो साथ ही",
    line2b: "कमाओ भी।",
    lead: [
      "भारत में एक ",
      "3½-वर्षीय जर्मन तकनीकी प्रशिक्षण कार्यक्रम",
      " — हैंडवर्क्सकैमर कोब्लेंज़ के साथ मिलकर बनाया गया। फैक्टरी-फ्लोर अप्रेंटिसशिप, दोहरा प्रमाणन और एक ठोस करियर जिस पर आप वास्तव में भरोसा कर सकें।",
    ],
    ctaBook: "अपनी सीट बुक करें",
    ctaExplore: "कोर्स देखें",
    metrics: [
      { k: "3.5", u: "वर्ष", l: "कार्यक्रम" },
      { k: "55K", u: "वर्ग फुट", l: "कैंपस" },
      { k: "₹1.5–4.8L", u: "", l: "शुरुआती / वर्ष *" },
      { k: "2×", u: "", l: "प्रमाणन" },
    ],
    imgTag: "शॉप फ्लोर · लाइव",
    imgLoc: "सेक्टर 75A · गुरुग्राम",
  },
  progQ: {
    overline: "अपनी स्ट्रीम चुनें · 3 कोर्स",
    kicker: "फुल-टाइम · 3.5 वर्ष · दोहरा प्रमाणन",
    p1: {
      stream: "मैकेनिकल",
      title: "टूल एंड डाई मेकिंग",
      blurb: "प्रेस टूल, मोल्ड डिज़ाइन, जिग्स व फिक्स्चर — उच्च-परिशुद्धता मशीनरी पर।",
    },
    p2: {
      stream: "इलेक्ट्रिकल एवं इलेक्ट्रॉनिक्स",
      title: "मेक्ट्रोनिक्स",
      blurb: "ऑटोमेशन, रोबोटिक्स, PLC/BUS और माइक्रोप्रोसेसर-चालित सिस्टम।",
    },
    p3: {
      stream: "मैकेनिकल",
      title: "प्रिसीज़न मशीनिस्ट",
      blurb: "CNC, VMC, EDM व वायर-कट — उच्च-सहनशीलता निर्माण कौशल।",
    },
  },
  why: {
    overline1: "क्यों KIKI",
    title1: "जो हमें अलग बनाती हैं",
    features: [
      { title: "सीखते हुए कमाएँ", body: "लाइव अप्रेंटिसशिप के पहले दिन से स्टाइपेंड।" },
      { title: "आवास सुविधा उपलब्ध", body: "बाहरी छात्रों के लिए ऑन-कैंपस रहने की व्यवस्था।" },
      { title: "दोहरा प्रमाणन", body: "HWK कोब्लेंज़ (जर्मनी) + भारत सरकार (MSDE/NSDC)।" },
      { title: "प्लेसमेंट रिकॉर्ड", body: "MNCs के साथ संरचित प्लेसमेंट पाइपलाइन।" },
      { title: "भारत व विदेश में नौकरी", body: "जर्मन नेटवर्क के ज़रिए वैश्विक अवसर।" },
    ],
    overline2: "आप जहाँ काम करेंगे",
    title2: "करियर अवसर",
    careers: [
      "कार कंपनियाँ",
      "ऑटोमोबाइल एन्सिलरी",
      "रोबोटिक्स फर्म",
      "एयरोस्पेस सप्लायर",
      "मोटरबाइक ब्रांड",
      "मशीन निर्माण",
      "इंजीनियरिंग कंपनियाँ",
      "प्रिसीज़न टूलरूम",
    ],
  },
  campus: {
    overline: "परिसर · सेक्टर 75A · गुरुग्राम",
    title: "कैंपस के अंदर",
  },
  journey: {
    overline: "यह कैसे काम करता है · 4 चरण",
    titleA: "पूछताछ से लेकर एक ",
    titleB: "करियर तक।",
    cta: "चरण 01 शुरू करें · पूछताछ करें",
    steps: [
      { title: "आवेदन व सत्यापन", body: "OTP-सत्यापित फ़ॉर्म भरें। हमारी टीम 24 घंटे के भीतर आपको कॉल करेगी।" },
      { title: "दाखिला व ऑनबोर्डिंग", body: "अपनी स्ट्रीम चुनें, दाखिला पूरा करें और आ जाएँ — बाहरी छात्रों के लिए ऑन-कैंपस आवास।" },
      { title: "प्रशिक्षण व कमाई", body: "लाइव मशीनरी पर सीखें, पहले दिन से स्टाइपेंड। 3½ वर्ष में दोहरा प्रमाणन।" },
      { title: "प्लेसमेंट व विकास", body: "भारत व विदेश के MNC नेटवर्क में स्नातक बनें — शुरुआत ₹1.5–4.8L / वर्ष।" },
    ],
  },
  progD: {
    heading: "पढ़ाई के साथ कमाई",
    subHeading: "— पढ़ें, कमाएँ और प्रमाणित हों। सब एक साथ।",
    regOpen: "✱ पंजीकरण खुला है",
    duration: "3½ वर्ष",
    durationLabel: "कार्यक्रम अवधि",
    durationPill: "अवधि : 3.5 वर्ष · फुल-टाइम",
    careersLabel: "कोर्स के बाद करियर",
    moreCareer: "+ और",
    enquireFor: "पूछताछ करें",
    p1: {
      code: "M-01",
      stream: "मैकेनिकल",
      title: "टूल एंड डाई मेकिंग",
      hindi: "टूल एंड डाई मेकिंग",
      modules: ["बेंचवर्क व मेट्रोलॉजी", "इंजीनियरिंग ड्रॉइंग", "क्वालिटी सिस्टम", "मटीरियल साइंस", "मिलिंग, टर्निंग", "ग्राइंडिंग, CNC", "EDM, वायर कट", "प्रेस टूल व मोल्ड डिज़ाइन", "न्यूमैटिक्स व हाइड्रोलिक्स", "AutoCAD, CAM", "अंग्रेज़ी, गणित", "कंप्यूटर, सॉफ्ट स्किल्स"],
      careers: ["टूल रूम", "टूल डिज़ाइन", "प्रोडक्शन इंजीनियर", "वेंडर डेवलपमेंट"],
    },
    p2: {
      code: "M-02",
      stream: "इलेक्ट्रिकल एवं इलेक्ट्रॉनिक्स",
      title: "मेक्ट्रोनिक्स",
      hindi: "मेक्ट्रोनिक्स",
      modules: ["बेंचवर्क व मेट्रोलॉजी", "इंजीनियरिंग ड्रॉइंग", "मटीरियल साइंस", "मिलिंग, टर्निंग", "ग्राइंडिंग, CNC", "इलेक्ट्रिकल व इलेक्ट्रॉनिक्स", "ड्राइव व सर्किट", "PLC, BUS सिस्टम", "माइक्रोप्रोसेसर कंट्रोल रूम", "अंग्रेज़ी, गणित", "कंप्यूटर, सॉफ्ट स्किल्स"],
      careers: ["मेंटेनेंस", "डेवलपमेंट / ऑटोमेशन", "क्वालिटी कंट्रोल", "प्रोडक्शन (इलेक्ट्रॉनिक्स)"],
    },
    p3: {
      code: "M-03",
      stream: "मैकेनिकल",
      title: "प्रिसीज़न मशीनिस्ट",
      hindi: "प्रिसीज़न मशीनिस्ट",
      modules: ["बेंचवर्क व मेट्रोलॉजी", "इंजीनियरिंग ड्रॉइंग", "क्वालिटी सिस्टम", "मटीरियल साइंस", "मिलिंग, टर्निंग", "ग्राइंडिंग", "CNC, VMC", "EDM, वायर कट", "AutoCAD", "अंग्रेज़ी, गणित", "कंप्यूटर, सॉफ्ट स्किल्स", "इंटरव्यू स्किल्स"],
      careers: ["टूल रूम", "प्रोडक्शन", "CNC इंजीनियर", "CNC प्रोग्रामर"],
    },
  },
  placement: {
    salaryLabel: "अनुमानित शुरुआती वेतन",
    perYear: "/ वर्ष",
    salaryNote: "नए स्नातकों के लिए — आपके कौशल और प्रदर्शन के अनुसार बढ़ता है।",
    certPill: "दोहरा प्रमाणन · HWK कोब्लेंज़ · जर्मनी",
    overline: "प्लेसमेंट नेटवर्क · भारत व विदेश",
    title: "जहाँ हमारे छात्र प्रशिक्षण और काम करते हैं",
    disclaimer: "* प्लेसमेंट आंतरिक मूल्यांकन, कम-से-कम एक मॉड्यूल पूरा करने और इंटरव्यू परिणामों पर निर्भर है। वेतन आँकड़े संकेतात्मक हैं।",
    origins: {
      japan: "जापानी MNC",
      indianMnc: "भारतीय MNC",
      indianCo: "भारतीय कंपनी",
      american: "अमेरिकी MNC",
      german: "जर्मन MNC",
      more: "प्लेसमेंट पार्टनर",
    },
  },
  gallery: {
    overline: "KIKI में जीवन · असली कैंपस, असली छात्र",
    titleA: "जहाँ शिल्प मिलता है ",
    titleB: "समुदाय से।",
    moments: "पल · सेक्टर 75A · गुरुग्राम",
    loadMore: "और तस्वीरें दिखाएँ",
  },
  testimonials: {
    overline: "पूर्व छात्रों की आवाज़ · असली छात्र",
    fromDay1: "पहले दिन से",
    stipendSalary: {
      a: "स्टाइपेंड",
      b: "+",
      c: "वेतन।",
    },
    stipendCopy: "हर KIKI अप्रेंटिस को लाइव अप्रेंटिसशिप के पहले दिन से भुगतान मिलता है — क्योंकि हुनर की क़ीमत होती है।",
    quotes: [
      {
        q: "KIKI का हिस्सा होकर मुझे गर्व है। यहाँ की गहन कोचिंग, सॉफ्ट-स्किल्स ट्रेनिंग और लैब — सबने मेरे इंटरव्यू के हर चरण के लिए आत्मविश्वास बढ़ाया।",
        name: "गुरजीत सिंह",
        role: "ऑन-जॉब ट्रेनी",
        company: "आत्मा ऑटोटेक इंजीनियर्स प्रा. लि.",
        origin: "मेक्ट्रोनिक्स · इलेक्ट्रिकल, इलेक्ट्रॉनिक्स व रोबोटिक्स",
      },
      {
        q: "मैंने पहले नियमित डिप्लोमा किया था पर नौकरी नहीं मिली। KIKI में लैटरल-एंट्री से जुड़ा — यहाँ के ट्रेनर्स ने मेरी ज़िंदगी बदल दी। आज मैं IFB बैंगलोर में ₹3.5L CTC पर हूँ।",
        name: "अरुण कुमार",
        role: "IFB इंडस्ट्रीज़ लि., बैंगलोर",
        company: "₹3.5L CTC · मार्च 2016 में स्नातक",
        origin: "मेक्ट्रोनिक्स · लैटरल एंट्री",
      },
      {
        q: "KIKI ने मुझे अपार ज्ञान दिया जो आज भी मेरे करियर में काम आता है। यहाँ का दोस्ताना माहौल दूसरी जगह नहीं मिलेगा। अब मैं IFB में टूल डिज़ाइनर हूँ।",
        name: "विकी कुमार",
        role: "टूल डिज़ाइनर · IFB इंडस्ट्रीज़, बैंगलोर",
        company: "₹3.1L CTC · मार्च 2016 में स्नातक",
        origin: "टूल एंड डाई मेकिंग",
      },
      {
        q: "KIKI में जर्मन भाषा निःशुल्क सिखाई जाती है — जर्मनी से आए Dr. Wolfgang Eckhardt द्वारा। हमारा कोर्स HWK कोब्लेंज़ प्रमाणित है, इसलिए हम यूरोप में भी नौकरी के लिए आवेदन कर सकते हैं। Danke!",
        name: "कँवलजीत सिंह",
        role: "अंतिम वर्ष के छात्र",
        company: "जर्मन भाषा · HWK कोब्लेंज़ प्रमाणित",
        origin: "टूल एंड डाई मेकिंग",
      },
      {
        q: "आज बोस्टन साइंटिफिक में इंटर्न के तौर पर मेरा पहला दिन था — DA Lab टीम में। हम पहले से डिज़ाइन किए गए मेडिकल उपकरणों का परीक्षण और कैलिब्रेशन करते हैं। इस अवसर के लिए KIKI का धन्यवाद।",
        name: "आशीष सिंह",
        role: "इंटर्न · बोस्टन साइंटिफिक",
        company: "डिज़ाइन एश्योरेंस लैब · MNC इंटर्नशिप",
        origin: "टूल एंड डाई मेकिंग · द्वितीय वर्ष",
      },
      {
        q: "KIKI का सॉफ्ट स्किल्स विषय सबसे उपयोगी निकला। कैसे बैठें से लेकर टीम में कैसे काम करें — अब मुझे पता है कि यह सफलता में कितनी बड़ी भूमिका निभाता है।",
        name: "जेसलिन मैथ्यू",
        role: "छात्र",
        company: "सॉफ्ट स्किल्स · व्यक्तित्व विकास",
        origin: "टूल एंड डाई मेकिंग",
      },
    ],
  },
  mentors: {
    overline: "फैकल्टी व मेंटर · जर्मन-प्रशिक्षित मास्टर",
    titleA: "सीखें ",
    titleB: "शिल्प के उस्तादों से।",
    lead: "हर KIKI बैच को मास्टर ट्रेनर, जर्मन-प्रमाणित प्रशिक्षक और उद्योग मेंटर आकार देते हैं — जिन्होंने दशकों शॉप फ्लोर पर बिताए हैं।",
    ctaKicker: "पूरी फैकल्टी से मिलें",
    ctaTitle: "ट्रेनर जिन्होंने सिर्फ़ पाठ्यक्रम नहीं — करियर बनाए हैं।",
    ctaLabel: "एडमिशन से बात करें",
    list: [
      { name: "Dr. Wolfgang Eckhardt", role: "जर्मन भाषा व संस्कृति", org: "HWK कोब्लेंज़ · जर्मनी", tag: "DE", bio: "कैंपस में निःशुल्क जर्मन सिखाते हैं — हर स्नातक के लिए EU के रास्ते खोलते हुए।" },
      { name: "राजेश मेनन", role: "मास्टर ट्रेनर · टूल एंड डाई", org: "28 वर्ष · प्रिसीज़न टूलरूम", tag: "TD", bio: "प्रेस-टूल, मोल्ड डिज़ाइन व मेट्रोलॉजी — जापानी व जर्मन लाइनों पर निखारा हुआ अनुभव।" },
      { name: "अनिल देशपांडे", role: "लीड · मेक्ट्रोनिक्स", org: "PLC · रोबोटिक्स · ऑटोमेशन", tag: "MT", bio: "लाइव औद्योगिक सिस्टम के इर्द-गिर्द ऑटोमेशन व कंट्रोल पाठ्यक्रम तैयार करते हैं।" },
      { name: "एस. कार्तिक", role: "लीड · प्रिसीज़न मशीनिंग", org: "CNC · VMC · EDM", tag: "PM", bio: "उच्च-सहनशीलता CNC शिल्प — पहले कट से प्रोडक्शन-ग्रेड आउटपुट तक।" },
      { name: "नेहा कपूर", role: "हेड · सॉफ्ट स्किल्स व प्लेसमेंट", org: "इंटरव्यू व करियर तैयारी", tag: "SP", bio: "तकनीकी प्रतिभा को आत्मविश्वासी, इंटरव्यू-तैयार पेशेवर में बदलती हैं।" },
    ],
  },
  fees: {
    overline: "फीस व स्कॉलरशिप · सत्र 2026",
    titleA: "एक निवेश जो ",
    titleB: "आपको लौटाता है।",
    lead: "KIKI एक स्टाइपेंड-समर्थित अप्रेंटिसशिप मॉडल पर चलता है। सटीक फीस, स्कॉलरशिप व वित्तीय सहायता के विकल्प काउंसलिंग कॉल में तय होते हैं — ट्रैक ऐसे काम करते हैं।",
    popular: "सबसे लोकप्रिय",
    note: "* आँकड़े संकेतात्मक हैं और काउंसलिंग में पुष्ट होते हैं। स्टाइपेंड वर्ष 2 व वर्ष 3 में बढ़ता है।",
    plans: [
      {
        name: "फाउंडेशन ट्रैक",
        priceLabel: "सामान्य प्रवेश",
        sub: "पूरा 3½-वर्षीय दोहरा-प्रमाणन कार्यक्रम।",
        features: ["दोहरा प्रमाणन — HWK कोब्लेंज़ + भारत सरकार", "असली मशीनरी पर लाइव शॉप-फ्लोर प्रशिक्षण", "जर्मन भाषा, निःशुल्क", "प्लेसमेंट-नेटवर्क तक पहुँच"],
        cta: "पूछताछ करें",
      },
      {
        name: "मेरिट स्कॉलरशिप",
        priceLabel: "100% तक फीस माफ़ी",
        sub: "शीर्ष आवेदकों के लिए प्रदर्शन-आधारित सहायता।",
        features: ["फाउंडेशन ट्रैक का सब कुछ", "प्रवेश पर मेरिट-आधारित स्कॉलरशिप", "प्राथमिकता कैंपस आवास", "मेंटर-मैच्ड प्लेसमेंट सहायता", "फास्ट-ट्रैक काउंसलिंग"],
        cta: "पात्रता जाँचें",
      },
      {
        name: "सीखते हुए कमाएँ",
        priceLabel: "पहले दिन से स्टाइपेंड",
        sub: "लाइव अप्रेंटिसशिप पर भुगतान — प्लेसमेंट पर ₹1.5–4.8L / वर्ष।",
        features: ["अप्रेंटिसशिप के पहले दिन से स्टाइपेंड", "हर वर्ष बढ़ती कमाई", "भारत व विदेश में नौकरियाँ", "जर्मन-नेटवर्क वैश्विक अवसर"],
        cta: "पूछताछ करें",
      },
    ],
  },
  faq: {
    overline: "सामान्य प्रश्न",
    titleA: "सवाल,",
    titleB: "जवाब।",
    callNote1: "अभी भी संदेह है? हमें ",
    callNote2: " पर कॉल करें या पूछताछ भेजें — असली जवाब, असली लोगों से।",
    items: [
      { q: "KIKI कार्यक्रम के लिए कौन पात्र है?", a: "सभी स्ट्रीम के 10वीं और 12वीं पास छात्र आवेदन कर सकते हैं। दाखिले के समय अभिवृत्ति, प्रेरणा और बुनियादी गणित का आकलन होता है।" },
      { q: "क्या यह एक मान्यता प्राप्त प्रमाणन है?", a: "जी हाँ। स्नातकों को हैंडवर्क्सकैमर कोब्लेंज़ (जर्मनी) और भारत सरकार (MSDE/NSDC) — दोनों से प्रमाणन मिलता है, जो पूरे EU में मान्य है।" },
      { q: "\"सीखते हुए कमाएँ\" का असल में क्या मतलब है?", a: "शॉप फ्लोर पर लाइव अप्रेंटिसशिप के पहले दिन से आपको स्टाइपेंड मिलता है। जिम्मेदारियाँ बढ़ने के साथ यह वर्ष 2 और वर्ष 3 में और बढ़ता है।" },
      { q: "क्या बाहरी छात्रों के लिए आवास मिलता है?", a: "हाँ। हमारे सेक्टर 75A कैंपस में बाहरी छात्रों के लिए ऑन-कैंपस आवास उपलब्ध है — कमरे, मेस और अध्ययन क्षेत्र सब शामिल।" },
      { q: "KIKI स्नातकों को कैसी नौकरियाँ मिलती हैं?", a: "टूल रूम, CNC/VMC, PLC प्रोग्रामिंग, क्वालिटी सिस्टम, प्रोडक्शन, सर्विस इंजीनियरिंग और इंस्ट्रुमेंटेशन — जापानी, जर्मन, अमेरिकी व भारतीय MNC में। जर्मन नेटवर्क के ज़रिए विदेशी अवसर भी।" },
      { q: "सत्र 2026 के लिए दाखिला कैसे होता है?", a: "इस पेज पर OTP-सत्यापित पूछताछ फ़ॉर्म भरें — हमारी एडमिशन टीम 24 घंटों में आपको प्रक्रिया, कैंपस विज़िट और पात्रता के बारे में बताएगी।" },
      { q: "फीस संरचना क्या है?", a: "KIKI एक स्टाइपेंड-समर्थित अप्रेंटिसशिप मॉडल है। कोर्स फीस, स्कॉलरशिप और वित्तीय सहायता के विकल्प काउंसलिंग कॉल में बताए जाते हैं।" },
      { q: "कैंपस कहाँ स्थित है?", a: "1/47, सेक्टर 75A, गुरुग्राम, हरियाणा 122012 — भारत के ऑटोमोटिव व प्रिसीज़न विनिर्माण क्षेत्र में।" },
    ],
  },
  contact: {
    overline: "अपनी सीट बुक करें · सत्र 2026",
    titleA: "तैयार हैं ",
    titleAItalic: "सीखने,",
    titleB: "कमाने ",
    titleBItalic: "व प्रमाणित होने के लिए?",
    lead: "OTP-सत्यापित पूछताछ फ़ॉर्म भरें या सीधे हमें कॉल करें। हमारी एडमिशन टीम 24 घंटों के भीतर जवाब देगी।",
    cta: "अभी पूछताछ करें",
    regLabel: "पंजीकरण केंद्र",
    addr: {
      line1: "KIKI सेंटर ऑफ टेक्नोलॉजी,",
      line2: "1/47, सेक्टर 75A,",
      line3: "गुरुग्राम,",
      line4: "हरियाणा — 122012",
    },
    newsLabel: "न्यूज़लेटर · सत्र 2026 अपडेट",
    newsTitle: "एडमिशन अपडेट, कैंपस विज़िट और ओपन-डे की तारीखें — सीधे आपके इनबॉक्स में।",
    newsPlaceholder: "aap@example.com",
    newsSubmit: "सब्सक्राइब",
    newsInvalid: "मान्य ईमेल दर्ज करें",
    newsAlready: "आप पहले से सूची में हैं।",
    newsSuccess: "स्वागत है। KIKI परिवार में आपका स्वागत है।",
    commitLabel: "हमारी दोहरी प्रतिबद्धता",
    commit1: "जर्मन मानक",
    commit2: "उद्योग-तैयार कौशल",
    mapLabel: "नक्शा · रास्ता जानें",
    mapDirections: "रास्ता जानें",
    mapOpen: "Google Maps में खोलें",
  },
  footer: {
    slogan: "जर्मन शिल्प · भारतीय जज़्बा",
    kickerA: "पढ़ें। कमाएँ।",
    kickerB: "प्रमाणित हों।",
    centre: "केंद्र",
    centreName: "KIKI सेंटर फॉर टेक्नोलॉजी",
    centreLoc: "सेक्टर 75A · गुरुग्राम 122012",
    partner: "पार्टनर",
    partnerSub: "जर्मन चैम्बर ऑफ स्किल्ड क्राफ्ट",
    session: "सत्र",
    sessionYear: "2026 प्रवेश",
    sessionSub: "प्रवेश खुले · 10वीं / 12वीं पास",
    contact: "संपर्क",
    copy: "© {year} KIKI सेंटर फॉर टेक्नोलॉजी · सर्वाधिकार सुरक्षित।",
    backTop: "ऊपर जाएँ ↑",
    admin: "एडमिन",
  },
  stickyCta: "पूछताछ",
  enq: {
    sessionKicker: "सत्र 2026 · पूछताछ",
    subKicker: "सत्यापित पूछताछ फ़ॉर्म",
    step1Title: "अपने बारे में बताएँ।",
    step1Sub: "सत्यापन के लिए हम आपके WhatsApp नंबर पर 6-अंकीय कोड भेजेंगे।",
    fName: "पूरा नाम",
    fNamePh: "रवि कुमार",
    fEmail: "ईमेल",
    fEmailPh: "aap@example.com",
    fPhone: "फ़ोन (WhatsApp)",
    fPhonePh: "+91 98xxxxxxxx",
    fProgramme: "कोर्स",
    fQualification: "योग्यता",
    fCity: "शहर",
    fCityPh: "गुरुग्राम",
    fMessage: "और कुछ? (वैकल्पिक)",
    fMessagePh: "प्रश्न, बैच वरीयता, आदि।",
    sendOtp: "सत्यापन कोड भेजें",
    submitEnquiry: "पूछताछ जमा करें",
    otpBadge: "OTP-सत्यापित · सुरक्षित WhatsApp सत्यापन",
    step2Title: "सत्यापित करें।",
    step2Sub: "हमने {email} पर 6-अंकीय कोड भेजा है। यह 10 मिनट में समाप्त हो जाएगा।",
    step2SubWa1: "हमने 6-अंकीय कोड ",
    step2SubWa2: " पर {phone} भेजा",
    step2SubWa3: " (और {email} पर भी)",
    step2SubWa4: "। यह 10 मिनट में समाप्त हो जाएगा।",
    fOtp: "सत्यापन कोड",
    verify: "सत्यापित करें व पूछताछ जमा करें",
    resend: "कोड फिर भेजें",
    change: "जानकारी बदलें",
    successTitle: "सत्यापित।",
    successTitle2: "आप सूची में हैं।",
    successBody: "हमारी एडमिशन टीम 24 घंटों के भीतर आपको कॉल करेगी और KIKI कार्यक्रम व कैंपस विज़िट के बारे में बताएगी।",
    close: "बंद करें",
    infoProgramme: "कोर्स",
    infoPhone: "फ़ोन",
    infoCity: "शहर",
    errEmail: "मान्य ईमेल पता दर्ज करें।",
    errPhone: "मान्य फ़ोन नंबर दर्ज करें।",
    errName: "कृपया अपना पूरा नाम दर्ज करें।",
    errCity: "कृपया अपना शहर दर्ज करें।",
    errOtp: "हमने ईमेल पर जो कोड भेजा है वह दर्ज करें।",
    codeSent: "सत्यापन कोड भेजा गया",
    codeSentEmail: "6-अंकीय कोड के लिए {email} देखें।",
    codeSentWa: "WhatsApp {phone}{alsoEmail} पर भेजा गया।",
    alsoEmail: " और आपके ईमेल पर भी",
    codeResent: "कोड फिर भेजा गया",
    codeSentWaToast: "WhatsApp पर कोड भेजा गया",
    resendWa: "WhatsApp पर फिर भेजें",
    step2SubWa: "हमने WhatsApp पर {phone} पर 6-अंकीय कोड भेजा है। यह 10 मिनट में समाप्त हो जाएगा।",
    submitted: "पूछताछ जमा हो गई",
    submittedSub: "हम 24 घंटों के भीतर संपर्क करेंगे।",
  },
};

const dict = { en, hi };

// ---------- Context ----------
const LangContext = createContext({ lang: "en", setLang: () => {}, toggle: () => {} });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("kiki_lang") : null;
    if (saved === "hi" || saved === "en") setLangState(saved);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    localStorage.setItem("kiki_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const setLang = (l) => setLangState(l === "hi" ? "hi" : "en");
  const toggle = () => setLangState((l) => (l === "en" ? "hi" : "en"));

  return (
    <LangContext.Provider value={{ lang, setLang, toggle }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

// Safe deep get with fallback. Supports {var} interpolation.
export function useT() {
  const { lang } = useLang();
  return (path, vars) => {
    const parts = String(path).split(".");
    let cur = dict[lang];
    for (const p of parts) {
      if (cur && typeof cur === "object" && p in cur) {
        cur = cur[p];
      } else {
        // fallback to English
        let curEn = dict.en;
        for (const p2 of parts) {
          if (curEn && typeof curEn === "object" && p2 in curEn) curEn = curEn[p2];
          else return path;
        }
        cur = curEn;
        break;
      }
    }
    if (typeof cur === "string" && vars) {
      return cur.replace(/\{(\w+)\}/g, (_, k) => (k in vars ? String(vars[k]) : `{${k}}`));
    }
    return cur;
  };
}
